import { render, staticRenderFns } from "./assignmentCreate.vue?vue&type=template&id=c197bbd8"
import script from "../../controllers/assignment/assignment-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/assignment/assignment-create.js?vue&type=script&lang=js&external"
import style0 from "./assignmentCreate.vue?vue&type=style&index=0&id=c197bbd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports